import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCircleCheck, lucideTriangleAlert } from '@ng-icons/lucide';
import { HlmAlertImports } from '@spartan-ng/helm/alert';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmTypographyImports } from '@spartan-ng/helm/typography';
import { LogoComponent } from '../../components/logo/logo.component';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  templateUrl: './verify-email.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterModule,
    NgIcon,
    HlmAlertImports,
    HlmButtonImports,
    HlmCardImports,
    HlmSpinnerImports,
    HlmTypographyImports,
    LogoComponent,
  ],
  providers: [provideIcons({ lucideCircleCheck, lucideTriangleAlert })],
})
export class VerifyEmailComponent implements OnInit {
  token: string = '';
  loading = false;
  verified = false;
  error = '';
  resending = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    // Get token from query parameters
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
      if (this.token) {
        this.verifyEmail();
      }
    });
  }

  verifyEmail() {
    if (!this.token) {
      this.error = 'Kein Verifizierungstoken gefunden.';
      return;
    }

    this.loading = true;
    this.error = '';

    this.authService.verifyEmail(this.token).subscribe({
      next: () => {
        this.verified = true;
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        if (error.status === 400) {
          this.error =
            error.error?.detail || 'Der Verifizierungslink ist ungültig oder abgelaufen.';
        } else {
          this.error = 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.';
        }
      },
    });
  }

  resendVerification() {
    // This would need to be implemented in the auth service
    // For now, we'll show a message
    this.resending = true;
    setTimeout(() => {
      this.resending = false;
      // In a real implementation, you would call the resend service
    }, 2000);
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
